export class EnumItem {
    Name:string;
    Value:number;

    constructor(name:string, value:number){
        this.Name = name;
        this.Value = value;
    }

    public static map(model:any):EnumItem{
        return new EnumItem(model.Name, model.Value);    
    }
}
